import {combineReducers} from 'redux';

import mealTypes from './meal-types/reducer';

export default combineReducers({
    mealTypes,
});
